export default __webpack_public_path__ + "static/media/icon_cancel.8bd80d49.png";